import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, Router} from "@angular/router";
import {KeycloakService} from "../../services/keycloak.service";
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-add-served-network-server',
  templateUrl: './add-served-network-server.component.html',
})
export class AddServedNetworkServerComponent implements OnInit {

  public jsName;
  public jsId;
  public jsVirtId;
  public showSearch = false;
  public searchText = '';
  public allNetworkServer:any[] = [];
  public allNSWithVirtId: any[] = [];
  public nsName;
  public nsVirtId;
  public subscriberId: string = "";
  public renderSubscriberId: boolean = false;
  public isEnable = false;
  public username: string = KeycloakService.username;

  private value:any = {};

  public selectedNS(value:any):void {
    this.searchText = value.split(",").splice(0)[0];
    this.isEnable = true;
    for(let nsValue of this.allNSWithVirtId) {
      if(nsValue.name == this.searchText){
        this.nsVirtId = nsValue.virtId;
        if(nsValue.protocolVersion != '1.0') this.renderSubscriberId = true;
        else this.renderSubscriberId = false;
      }
    }
  }

  public removed(value:any):void {
    this.isEnable = false;
  }

  constructor(private router: Router,
              private route: ActivatedRoute,
              private _location: Location,
              private http: HttpClient) { }

  save(){
    var body: any = {
      "nsId": this.nsVirtId,
      "jsId": this.jsVirtId
      //"subscriberId": this.subscriberId
    };
    var url = ApiEndpoints.CREATE_ACTIVATION_AGREEMENT;
    const headers = new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'my-auth-token'
      });
    let options =  {headers: headers}
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this._location.back();
        }
      );
  }

  getAllNSWithSearch(virtId){
    var url = ApiEndpoints.GET_ALL_NETWORK_SERVERS_WOA;
    var body = {
      "virtID" : virtId
    };
    const headers = new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers}
    this.http.post<Array<any>>(url, body, options).subscribe(
        data => {
          for(let index of data){
            this.allNetworkServer.push(index.name + ", " + index.netIds.toString());
            this.allNSWithVirtId.push(index);
          }
        }
      );

  }

  backClicked() {
    this._location.back();
  }

  ngOnInit() {
    this.getAllNSWithSearch(this.route.snapshot.queryParams["virtId"]);
    this.jsName = this.route.snapshot.queryParams["name"];
    this.jsId = this.route.snapshot.queryParams["id"].toString();
    this.jsVirtId = this.route.snapshot.queryParams["virtId"];

    $(document).ready(function () {

      $('.ui.dropdown')
        .dropdown({
          allowAdditions: true
        });

    });
  }

}
